<template>
  <div></div>
</template>

<script>
import { OPLITUDE_ACCESS_URL } from "@/config";

export default {
  name: "ExternalRedirect",
  props: {
    url: {
      type: String,
      default: OPLITUDE_ACCESS_URL,
    },
  },
  created() {
    window.location.replace(this.url);
  },
};
</script>
